import { createSlice } from '@reduxjs/toolkit'

export type RecurringPaymentsFilters = {
  cardFilter: string
  dateFilter: number | string
  calendarStartDate: Date | null
  calendarEndDate: Date | null
  showCalendar: boolean
}

export type RecurringPaymentsFetchParams = {
  cardId?: string
  daysSinceToday?: number
  startDate?: string
  endDate?: string
}

const initialFilters: RecurringPaymentsFilters = {
  cardFilter: 'All',
  dateFilter: 30,
  calendarStartDate: null,
  calendarEndDate: null,
  showCalendar: false,
}

const initialState = {
  transactions: null as any[] | null,
  users: null as any[] | null,
  hasPayments: false,
  nextPageHref: '',
  isLoading: false,
  isLoadingMore: false,
  error: false,
  filters: initialFilters,
}

const bdmcRecurringPaymentsSlice = createSlice({
  name: 'bdmcRecurringPayments',
  initialState,
  reducers: {
    fetchStart(state) {
      state.isLoading = true
      state.error = false
    },
    fetchSuccess(state, action) {
      const { recurringPaymentTrx, recurringPaymentUsers, hasRecurringPayments, nextPageHref } =
        action.payload
      state.transactions = recurringPaymentTrx
      state.users = recurringPaymentUsers
      state.hasPayments = hasRecurringPayments
      state.nextPageHref = nextPageHref
      state.isLoading = false
    },
    fetchFailure(state) {
      state.error = true
      state.isLoading = false
      state.transactions = null
    },
    loadMoreStart(state) {
      state.isLoadingMore = true
      state.error = false
    },
    loadMoreSuccess(state, action) {
      const { recurringPaymentTrx, nextPageHref } = action.payload
      state.transactions = [...(state.transactions || []), ...recurringPaymentTrx]
      state.nextPageHref = nextPageHref
      state.isLoadingMore = false
    },
    loadMoreFailure(state) {
      state.error = true
      state.isLoadingMore = false
    },
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload }
    },
  },
})

export const selectBdmcRecurringTransactions = (state: any) =>
  state.bdmcRecurringPayments.transactions
export const selectBdmcRecurringUsers = (state: any) => state.bdmcRecurringPayments.users
export const selectBdmcRecurringHasPayments = (state: any) =>
  state.bdmcRecurringPayments.hasPayments
export const selectBdmcRecurringNextPageHref = (state: any) =>
  state.bdmcRecurringPayments.nextPageHref
export const selectBdmcRecurringIsLoading = (state: any) => state.bdmcRecurringPayments.isLoading
export const selectBdmcRecurringIsLoadingMore = (state: any) =>
  state.bdmcRecurringPayments.isLoadingMore
export const selectBdmcRecurringError = (state: any) => state.bdmcRecurringPayments.error
export const selectBdmcRecurringFilters = (state: any) => state.bdmcRecurringPayments.filters

export const {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  loadMoreStart,
  loadMoreSuccess,
  loadMoreFailure,
  setFilters,
} = bdmcRecurringPaymentsSlice.actions

export default bdmcRecurringPaymentsSlice.reducer
